import WorkoutPreview from './WorkoutPreview';

export default WorkoutPreview;
